module.exports = __webpack_public_path__ + "static/media/Jeepers-01.67e18575.svg";